import { Field, Form, Formik } from "formik";
import React, { useState } from "react";
import { updateData } from "../../hooks/update";
import { apiPath } from "../../utility/Constant";

const JobsCreate = () => {
  const { jobsApi } = apiPath;
  const [submitButtonDisable, setSubmitButtonDisable] = useState(false);
  const labelFieldCss = `label`;
  const textAreaFieldCss = `textarea textarea-bordered h-24 w-full`;
  const inputFieldCss = `input input-bordered w-full z-0`;
  const inputContainerDiv = `mb-4 relative over`;

  const handleFormSubmit = async (values) => {
    try {
      setSubmitButtonDisable(true);
      const data = values;
      updateData(jobsApi, data, false, null, null, true);
    } catch (error) {
      console.error("Error while submitting form:", error);
    }
  };
  return (
    <div className="container mx-auto lg:pt-24 py-10 px-5 lg:px-16">
      <Formik
        initialValues={{
          title: "",
          queryTitle: "",
          exp: "",
          description: "",
        }}
        onSubmit={handleFormSubmit}
        render={({ values, setFieldValue }) => (
          <Form>
            <div className="grid grid-cols-2 gap-5 overflow-hidden pt-5">
              <div className={`${inputContainerDiv} col-span-2 md:col-span-1`}>
                <label htmlFor="title" className="label">
                  <span>
                    {" "}
                    Job Title{" "}
                    <span className="text-red-500 text-md font-semibold">
                      &nbsp;*
                    </span>
                  </span>
                </label>
                <Field
                  placeholder="Job Title"
                  id="title"
                  name="title"
                  type="text"
                  autoComplete="text"
                  required
                  className={inputFieldCss}
                />
              </div>

              <div className={`${inputContainerDiv} col-span-2`}>
                <label htmlFor="queryTitle" className={labelFieldCss}>
                  Slug title
                </label>
                <Field
                  placeholder="Please provide a sentence that is space-free and strive to prevent data duplication."
                  id="queryTitle"
                  name="queryTitle"
                  type="text"
                  autoComplete="text"
                  className={inputFieldCss}
                />
              </div>
              <div className={`${inputContainerDiv} col-span-2`}>
                <label htmlFor="discount" className={labelFieldCss}>
                  Experience
                </label>
                <Field
                  placeholder="experience"
                  id="exp"
                  name="exp"
                  type="text"
                  autoComplete="text"
                  className={inputFieldCss}
                />
              </div>
              <div className={`${inputContainerDiv} col-span-2 md:col-span-1`}>
                <label htmlFor="live" className={labelFieldCss}>
                  <span>
                    Job Status
                    <span className="text-red-500 text-md font-semibold">
                      {" "}
                      &nbsp;*
                    </span>
                  </span>
                </label>
                <Field
                  as="select"
                  id="live"
                  name="live"
                  className={inputFieldCss}
                  required
                >
                  <option value="none">Select An Option</option>
                  <option value="true">Active</option>
                  <option value="false">Inactive</option>
                </Field>
              </div>
              <div className={`${inputContainerDiv} col-span-2`}>
                <label htmlFor="discount" className={labelFieldCss}>
                  Description
                </label>
                <Field
                  as="textarea"
                  placeholder="description"
                  id="description"
                  name="description"
                  type="text"
                  autoComplete="text"
                  className={textAreaFieldCss}
                />
              </div>
            </div>
            <div className="mt-16 mx-auto flex justify-center">
              <button type="submit" className="btn btnW7ide hover:bg-gray-100">
                Submit
              </button>
            </div>
          </Form>
        )}
      />
    </div>
  );
};

export default JobsCreate;
